import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { SikdaeGroupStatsForm, SikdaeGroupStatsResult } from 'components/SikdaeGroupStats';
import { LoadingBar } from 'components/Commons';

import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class SikdaeGroupStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sikdaeGroupVal: 0
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);

    //식대그룹 조회
    this.sikdaeGroup();

    this.groupStatsList();
  }

  componentDidMount() {
    cm.mainTitle('식대 그룹 통계');
  }

  //식대 그룹 조회
  sikdaeGroup = async () => {
    const { cmAPI } = this.props;
    try {
      await cmAPI.sikdaeGroupList();
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
      const { response } = e;
      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }
    } finally {
      // 조회 실패(reject·errorBind) 시 sikdaeGroup이 비어 로딩바가 안 꺼지므로 실패 표시
      const { sikdaeGroup } = this.props;
      if (!sikdaeGroup) this.setState({ groupFailed: true });
    }
  };

  //식대그룹 search
  sikdaeGroupSearch = async () => {
    const { groupIdx } = this.props;
    if (groupIdx.value !== 0) {
      const { cmAPI } = this.props;
      try {
        //식대정책 조회
        await cmAPI.sikdaePolicyList(groupIdx.value);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }
    }
    this.setState({ sikdaeGroupVal: groupIdx.value });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }
    this.groupStatsList();
  };

  groupStatsList = () => {
    const { date, groupIdx, policyIdx, usageAPI } = this.props,
      params = {
        startdate: date
          ? date.sDate
          : moment()
              .startOf('month')
              .format('LLL'),
        enddate: date ? date.eDate : moment().format('LLL'),
        groupidx: groupIdx ? groupIdx.value : null,
        policyidx: policyIdx ? policyIdx.value : null
      };

    usageAPI.groupStatList(params);

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: params
    });
  };

  render() {
    const { sikdaeGroupVal, groupFailed } = this.state,
      {
        date,
        groupIdx,
        groupStats,

        sikdaeGroup,
        sikdaePolicy
      } = this.props,
      formFn = {
        sikdaeGroupVal: sikdaeGroupVal,
        sikdaeGroup: sikdaeGroup,
        sikdaeGroupSearch: this.sikdaeGroupSearch,
        sikdaePolicy: sikdaePolicy,
        submitForm: this.submitForm
      };

    let loading = '';
    if (!(date && (sikdaeGroup || groupFailed) && groupIdx && groupStats)) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        {loading}

        <SikdaeGroupStatsForm formFn={formFn} />

        <SikdaeGroupStatsResult />
      </main>
    );
  }
}

SikdaeGroupStats = connect(
  (state) => ({
    //commons
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    sikdaeGroup: state.commons.sikdaeGroup,
    groupIdx: state.commons.group,
    sikdaePolicy: state.commons.sikdaePolicy,
    policyIdx: state.commons.policy,

    //stats
    groupStats: state.usage.groupStats
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList,
        sikdaePolicyList: cm_action.SikdaePolicyList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),

    usageAPI: bindActionCreators(
      {
        groupStatList: usg_action.GroupStatsList
      },
      dispatch
    )
  })
)(SikdaeGroupStats);

export default SikdaeGroupStats;
